var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_vm.isGranted == null ? [_c('employers-item-grant-confirm', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "outlined": "",
            "width": "100",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v(" 승인요청 ")])])];
      }
    }], null, false, 3186452305)
  }, 'employers-item-grant-confirm', {
    value: _vm.value,
    program: _vm.program,
    isUserHost: _vm.isUserHost
  }, false), {
    input: _vm.input
  }))] : _vm._e(), _vm.isGranted == true ? [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "100",
      "color": "secondary lighten-5"
    }
  }, [_c('span', {
    staticClass: "secondary--text"
  }, [_vm._v(" 승인완료 ")])])] : _vm._e(), _vm.isGranted == false ? [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "100",
      "color": "grey-ec"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 승인거부 ")])])] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }